import { render, staticRenderFns } from "./repairRecords.vue?vue&type=template&id=076826d1&"
import script from "./repairRecords.vue?vue&type=script&lang=js&"
export * from "./repairRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "repairRecords.vue"
export default component.exports